import axios from 'axios'
import {BASE_URL} from './baseUrl'
import md5 from 'md5'
import store from '../../store/index'
import {Loading, Message} from 'element-ui'
// import state from '../../store/index'

let loading = null // 在全局请求和响应拦截器中添加请求状态
let singkey = '6f2e17ceb7fd4c407f04d06ee70e017b';

function getSign(obj) {
    let currentTime = new Date().getTime();
    let sing;
    if(obj.data.params == null){
        obj.data.params = {};
    }
    sing = md5(JSON.stringify(obj.data.params) + currentTime + singkey);
    // console.log(sing);
    obj.data.timestamp = currentTime;
    obj.data.sign = sing;
    return obj;
}

//基础配置
const $http = axios.create({
    timeout: 10000, // 设置超时时间
    baseURL: BASE_URL,
    headers: {
        'Content-Type':'application/json; charset=utf-8',
        // 'Accept-Language':'en-US,en;q=0.9,zh-CN;q=0.8,zh;q=0.7',
    }
})

// 添加请求拦截器
$http.interceptors.request.use(
    config => {
        if(store.state.memu.lang==="en"){
            loading = Loading.service({text: 'Loding...'})
        }
        else {
            loading = Loading.service({text: '拼命加载中'})
        }

        var userInfo = store.state.userInfo.userInfo
        // config.headers.Authorization = 'Bearer ' + userInfo.tokenData
        if (!!userInfo){
            config.headers.Authorization = 'Bearer' + userInfo.token // 请求头部添加token
        }
        if (config.method == 'get') {
            config.data = true; //get请求不允许加"Content-Type"
            return config
        }
        return getSign(config);
    },
    error => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);
/**
 * 响应拦截器open
 * 用于处理loading状态关闭、请求成功回调、响应错误处理
 */
$http.interceptors.response.use(
    response => {
        loading = Loading.service({text: '拼命加载中'})
        if (loading) {
            loading.close()
        }
        const code = response.status
        // 请求成功返回response.data
        if ((code >= 200 && code < 300) || code === 304) {

            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
    },
    error => {
        if (loading) {
            loading.close()
        }
        if (error.response) {
            switch (error.response.status) {
                case 404:
                    Message.error('网络请求不存在')
                    break
                default:
                    Message.error(error.response.data.message)
            }
        } else {
            // 请求超时或者网络有问题
            if (error.message.includes('timeout')) {
                Message.error('请求超时！请检查网络是否正常')
            } else {
                Message.error('请求失败，请检查网络是否已连接')
            }
        }
        return Promise.reject(error)
    }
)

export default $http


